// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"511a51d7","455":"62960799","977":"15dd6fc1"}[chunkId] + ".chunk.js";
};